export default function EmbeddedProductsPreview() {

  const club = { id: 101, country: "GB" };

  const subscription = [
    { id: 201, name: "Unlimited Classes", price: 3999, interval: "monthly", description: "Join any class for a month" },
    // { id 
  ];

  const payAsGo = [
    // { id: 301, name: "Single Class Pass", price: 899, token: 1, description: "One pass for any class" },
    { id: 302, name: "Five Class Bundle", price: 3499, token: 5, description: "Five flexible passes" }
  ];

  function ConvertToCurrency(amount, country) {
    let currency = "GBP";
    let locale = "en-GB";
    if (country === "US") { currency = "USD"; locale = "en-US"; }
    if (country === "AU") { currency = "AUD"; locale = "en-AU"; }
    if (country === "CA") { currency = "CAD"; locale = "en-CA"; }
    return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount / 100);
  }

  function goTopLevel(url) {
    window.location.href = url;
  }

  return (
    <div className="container py-4">
      <h3 className="fw-bold text-center mb-3">Subscriptions</h3>
      <div className="list-group mb-4">
        {subscription.map((p) => (
          <div key={p.id} className="list-group-item p-3 shadow-sm mb-3 rounded">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="mb-1 fw-semibold">{p.name}</h5>
                <small className="text-muted">
                  {p.interval.charAt(0).toUpperCase() + p.interval.slice(1)} recurring payment
                </small>
              </div>
              <span className="badge fs-6 bg-dark text-light">
                {ConvertToCurrency(p.price, club.country)}
              </span>
            </div>
            <div className="text-muted small mt-2">{p.description}</div>
            <div className="mt-3">
              <button
                className="btn btn-primary"
              
              >
                Subscribe
              </button>
            </div>
          </div>
        ))}
      </div>

      <h3 className="fw-bold text-center mb-3">Flexible Class Passes</h3>
      <div className="list-group">
        {payAsGo.map((p) => (
          <div key={p.id} className="list-group-item p-3 shadow-sm mb-3 rounded">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="mb-1 fw-semibold">{p.name}</h5>
                <small className="text-muted">Classes: {p.token}</small>
              </div>
              <span className="badge fs-6 bg-dark text-light">
                {ConvertToCurrency(p.price, club.country)}
              </span>
            </div>
            <div className="text-muted small mt-2">{p.description}</div>
            <div className="mt-3">
              <button
                className="btn btn-primary"
              
              >
                Buy
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
